import React, { useState } from "react";
import { PiEyeClosedLight } from "react-icons/pi";
import { BsEye } from "react-icons/bs";

const InputRegister = ({
    className,
    placeholder,
    label,
    name,
    value,
    onChange,
    error,
    type = "text",
    onBlur,
    mandatory,
    required,
    readOnly,
    max,
    min,
    maxLength,
    border
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    const isPassword = type === "password";

    return (
        <div className="mb-[8px]">
            <label className="block text-sm font-medium text-gray-600 mb-1">
                {label}
                {readOnly ? <sup className="text-xs text-slate-600"> (not editable)</sup> 
                : (mandatory && <sup className="text-red-500 text-sm"> *</sup>)}
            </label>
            <div className="relative">
                <input
                    type={isPassword && showPassword ? "text" : type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={` ${placeholder}`}
                    onBlur={onBlur}
                    required={required}
                    readOnly={readOnly || false}
                    max={max}
                    min={min}
                    maxLength={maxLength}

                    // className={`${className} border px-3 py-3 rounded-lg focus:outline-none ${error ? "border-red-500" : "border-gray-300"
                    //     }`}
                    className={`${border ? "border" : "shadow"} rounded-lg px-3 py-3 text-sm mt-1 focus:outline-none focus:ring-2 ${error ? "border-red-500" : "border-gray-200"
                        } ${className}`}
                    
                />
                {isPassword && (
                    <button
                        type="button"
                        onClick={togglePassword}
                        className="absolute inset-y-0 right-3 flex items-center"
                    >
                        {showPassword ? <BsEye size={20} /> : <PiEyeClosedLight size={20} />}
                    </button>
                )}
            </div>
            {error&& (
                <div className=" bg-red-100 rounded-md h-auto">
                    <p className="text-red-500 text-sm mt-1 ml-3">{error}</p>
                </div>
            )}
        </div>
    );
};

export default InputRegister;

